import React from 'react';

const baseProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  viewBox: '0 0 24 24',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
};

export function ChevronDownIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

export function ChevronRightIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <polyline points="9 6 15 12 9 18" />
    </svg>
  );
}

export function PlusIcon({ size = 16, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

export function MinusIcon({ size = 16, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

export function CheckIcon({ size = 24, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export function XIcon({ size = 20, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

export function StarIcon({ size = 20, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps} fill="currentColor" stroke="none">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  );
}

export function CarFrontIcon({ size = 28, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <path d="M21 8L19 3.5A2 2 0 0 0 17.13 2H6.87A2 2 0 0 0 5 3.5L3 8" />
      <path d="M3 8h18a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2z" />
      <line x1="7" y1="13" x2="7" y2="13" />
      <line x1="17" y1="13" x2="17" y2="13" />
      <path d="M5 18v2" />
      <path d="M19 18v2" />
    </svg>
  );
}

export function FileTextIcon({ size = 28, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="9" y1="13" x2="15" y2="13" />
      <line x1="9" y1="17" x2="15" y2="17" />
      <line x1="9" y1="9" x2="11" y2="9" />
    </svg>
  );
}

export function UserCheckIcon({ size = 28, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="8.5" cy="7" r="4" />
      <polyline points="17 11 19 13 23 9" />
    </svg>
  );
}

export function SpeedometerIcon({ size = 16, className = '' }) {
  return (
    <svg width={size} height={size} className={className} {...baseProps}>
      <path d="M12 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
      <path d="M12 2a10 10 0 1 0 10 10" />
      <path d="M12 8V4" />
    </svg>
  );
}

// MaterialCommunityIcons "car-shift-pattern" - H-gate gear shift used for
// transmission in the listings feed spec row.
export function CarShiftPatternIcon({ size = 16, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M5 3C4.5 3 4 3.2 3.6 3.6 3.2 4 3 4.5 3 5v14c0 .5.2 1 .6 1.4.4.4.9.6 1.4.6h14c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4V5c0-.5-.2-1-.6-1.4C20 3.2 19.5 3 19 3H5m6 2h2v14h-2V5M5 5h4v6H5V5m0 8h4v6H5v-6m10-8h4v6h-4V5m0 8h4v6h-4v-6Z" />
    </svg>
  );
}

// MaterialCommunityIcons "map-marker-distance" - location pin used for the
// distance/city item in the listings feed spec row.
export function MapMarkerDistanceIcon({ size = 16, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M6.5 8.11A1.61 1.61 0 0 1 4.89 6.5 1.61 1.61 0 0 1 6.5 4.89 1.61 1.61 0 0 1 8.11 6.5 1.61 1.61 0 0 1 6.5 8.11M6.5 2A4.5 4.5 0 0 0 2 6.5C2 9.87 6.5 14.86 6.5 14.86S11 9.87 11 6.5A4.5 4.5 0 0 0 6.5 2M17.5 8.11A1.61 1.61 0 0 1 15.89 6.5 1.61 1.61 0 0 1 17.5 4.89 1.61 1.61 0 0 1 19.11 6.5 1.61 1.61 0 0 1 17.5 8.11M17.5 2A4.5 4.5 0 0 0 13 6.5c0 3.37 4.5 8.36 4.5 8.36S22 9.87 22 6.5A4.5 4.5 0 0 0 17.5 2M14 22v-2h-4v2h4m2 0v-2h6v2h-6M2 22v-2h6v2H2Z" />
    </svg>
  );
}

// ============ OneFeed category icons (ported from v2.1) ============

export function FranchisedDealersIcon({ size = 26, className = '' }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 24 V11 L9 7 L15 11 V24 Z" />
      <path d="M15 24 V14 L21 11 L25 13 V24 Z" />
      <rect x="6" y="14" width="3" height="3" />
      <rect x="6" y="19" width="3" height="3" />
      <rect x="18" y="16" width="3" height="3" />
    </svg>
  );
}

export function IndependentDealersIcon({ size = 26, className = '' }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M14 4 a3 3 0 0 1 3 3 a3 3 0 0 1 -3 3 L14 16 L8 22 a2.8 2.8 0 0 1 -4 -4 L10 12" />
      <circle cx="6" cy="20" r="1.2" fill="currentColor" />
      <path d="M19 13 L25 19 a2 2 0 0 1 0 3 a2 2 0 0 1 -3 0 L16 16" />
    </svg>
  );
}

export function OnlineMarketplacesIcon({ size = 26, className = '' }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="22" height="15" rx="2" />
      <path d="M11 24 H17 M14 20 V24" />
      <path d="M7 9 H11 M13 9 H17 M19 9 H21 M7 12 H10 M12 12 H15 M17 12 H21 M7 15 H13 M15 15 H21" />
    </svg>
  );
}

export function CarSupermarketsIcon({ size = 26, className = '' }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 11 L14 5 L25 11 V22 H3 Z" />
      <path d="M3 22 V13 H25" />
      <path d="M9 22 V16 H13 V22 M17 18 H21 M17 21 H21" />
    </svg>
  );
}

export function AuctionTradeIcon({ size = 26, className = '' }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 18 L13 10" />
      <path d="M9 6 L17 14" />
      <rect x="13" y="8" width="6" height="4" rx="1" transform="rotate(45 16 10)" />
      <path d="M3 24 H15" />
      <path d="M19 16 L24 21 M21 14 L26 19" />
    </svg>
  );
}

// ============ HowItWorks step icons (ported from v2.1) ============

export function ClipboardIcon({ size = 26, className = '' }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="6" y="3" width="16" height="22" rx="2" />
      <path d="M10 3 V1 h8 V3" />
      <path d="M9 10 h2 M14 10 h6 M9 15 h2 M14 15 h6 M9 20 h2 M14 20 h4" />
    </svg>
  );
}

export function SearchCheckIcon({ size = 26, className = '' }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="7" />
      <path d="M17 17 L23 23" />
      <path d="M9 12 L11.5 14 L15 10.5" />
    </svg>
  );
}

export function CalculatorIcon({ size = 26, className = '' }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="5" y="3" width="18" height="22" rx="2" />
      <rect x="8" y="6" width="12" height="4" />
      <circle cx="10" cy="14" r="1" fill="currentColor" />
      <circle cx="14" cy="14" r="1" fill="currentColor" />
      <circle cx="18" cy="14" r="1" fill="currentColor" />
      <circle cx="10" cy="18" r="1" fill="currentColor" />
      <circle cx="14" cy="18" r="1" fill="currentColor" />
      <path d="M17 18 L20 18 L20 22 L17 22 Z" />
    </svg>
  );
}

export function ChatCheckIcon({ size = 26, className = '' }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M24 14 c0 5 -5 8 -10 8 c-1.5 0 -3 -.2 -4.3 -.6 L5 23 l1.5 -4.2 C5.5 17.4 5 15.7 5 14 c0 -5 5 -8 10 -8 s9 3 9 8 z" />
      <path d="M11 13 L14 16 L19 11" />
    </svg>
  );
}
